export default __webpack_public_path__ + "static/media/sleeb.a3961c62.gif";